const toolbar = ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript', 'hr bullist numlist link  charmap preview  pagebreak insertdatetime  table emoticons forecolor backcolor ']
export default toolbar
